module.exports = __webpack_public_path__ + "img/SPICE_Logo.92ed7b94.png";